import * as z from "zod/v4";

export const refundidIntegrationSchema = z.object({
  apiKey: z.string(),
  shopId: z.string(),
  enabled: z.boolean(),
});

export const getRefundidIntegration = {
  name: "getRefundidIntegration" as const,
  input: z.object({}),
  output: z.object({
    refundidIntegration: refundidIntegrationSchema.nullable(),
  }),
};
